// /k/:token — a kiosk link (docs/architecture.md §11.6). The token leaves the address bar at once, is exchanged for
// the kiosk cookie (POST /auth/kiosk), and the screen goes to its dashboard. /k alone says the link no longer works
// (a revoked kiosk lands here).

import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { FullPage } from '../components/Shell.tsx';
import { Alert, Logo, Spinner } from '../components/ui.tsx';
import { useI18n } from '../i18n/index.ts';
import { api } from '../lib/api.ts';
import { keys } from '../lib/queries.ts';

export function KioskOpen() {
  const { token } = useParams();
  const { t } = useI18n();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [failed, setFailed] = useState(!token);

  useEffect(() => {
    if (!token) return;
    window.history.replaceState(null, '', '/k');
    let cancelled = false;
    api('/auth/kiosk', { method: 'POST', body: { token } }).then(async () => {
      qc.clear();
      await qc.invalidateQueries({ queryKey: keys.me });
      if (!cancelled) navigate('/', { replace: true });
    }, () => !cancelled && setFailed(true));
    return () => { cancelled = true; };
  }, [token, qc, navigate]);

  return (
    <FullPage>
      <div className="flex max-w-md flex-col items-center gap-6 text-center">
        <Logo wordmark={<span>Maillon Froid</span>} />
        {failed ? <Alert tone="amber" title={t('kiosk.invalid')}>{t('kiosk.invalidBody')}</Alert> : <Spinner label={t('kiosk.opening')} />}
      </div>
    </FullPage>
  );
}
